var React = require('react');

function EmptyProfile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M533.4,529.1c-10.9-72.2-75.5-131.9-165.4-151v-30.3c35.6-31,59.6-88.8,59.6-154.9V181\n\tc0-79-53.5-143.2-119.3-143.2S189,102,189,181v11.9c0,66,23.9,123.8,59.5,154.8v30.2c-90,19.1-154.6,78.8-165.5,151\n\tc-1.3,9.8,8.5,17.1,17.2,12.8c3.5-1.7,5.9-5,6.5-8.8c9.9-64,72.4-118.6,155.8-133.3c5.7-1,9.9-6,9.9-11.8v-24.2\n\tc11.3,5.4,23.4,8.3,35.9,8.3s24.5-2.9,35.8-8.2V388c0,5.8,4.2,10.7,9.9,11.7C437.4,414.4,499.9,469,509.8,533\n\tc0.6,3.8,3.1,7.1,6.5,8.8C525,546,534.8,538.7,533.4,529.1z M212.8,192.8v-11.9c0-65.8,42.9-119.3,95.5-119.3s95.4,53.6,95.5,119.3\n\tv11.9c0,85.5-42.9,155.1-95.5,155.1C255.6,347.9,212.8,278.3,212.8,192.8z"}));
}

EmptyProfile.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 600 600","style":{"enableBackground":"new 0 0 600 600"},"xmlSpace":"preserve"};

module.exports = EmptyProfile;

EmptyProfile.default = EmptyProfile;
